import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { OrderReviewContext } from '../QaOrderReview/OrderReviewContext';
import { removeOrderFormHeaderById } from '../../services';

const styles = theme => ({});

const propTypes = {
  classes: PropTypes.object.isRequired,
};

const RemoveOrderFormHeaderDialog = ({ classes, history }) => {
  const { state, dispatch } = useContext(OrderReviewContext);
  const [error, setError] = useState(null);

  const handleClose = () => {
    setError(null);
    dispatch({
      type: 'UPDATE_ORDER_FORM_HEADER_TO_REMOVE',
      orderFormHeader: null,
    });
  };

  const removeOrderFormHeader = async () => {
    setError(null);
    try {
      const result = await removeOrderFormHeaderById(
        state.orderLineId,
        state.orderFormHeaderToRemove.orderFormHeaderId,
      );
      dispatch({
        type: 'REMOVE_ORDER_FORM_HEADER_SUCCESS',
        orderFormHeaderId: state.orderFormHeaderToRemove.orderFormHeaderId,
      });
      handleClose();

      state.getOrderInfo && state.getOrderInfo();
    } catch (error) {
      console.log(error);
      if (error.response?.status === 403) {
        let message = "You don't have permission to remove this form";
        if (error.response?.data) {
          if (typeof error.response.data === 'string') {
            message = error.response.data;
          } else if (error.response.data.message) {
            message = error.response.data.message;
          }
        }
        setError(message);
      } else {
        setError('An error occurred while removing the form');
      }
    }
  };

  return (
    <Dialog
      open={Boolean(state.orderFormHeaderToRemove)}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>{error ? 'Cannot Remove Form' : 'Confirm Remove Form'}</DialogTitle>
      <DialogContent
        dividers
        style={{
          borderTop: '0.8px solid #ddd',
          borderBottom: '0.8px solid #ddd',
          paddingTop: 20,
        }}
      >
        {error ? (
          <div style={{ color: '#d32f2f' }}>{error}</div>
        ) : (
          'Are you sure you want to remove this form and all of its questions? This is a destructive action and data cannot be recovered.'
        )}
      </DialogContent>
      <DialogActions>
        {!error && (
          <Button
            onClick={removeOrderFormHeader}
            variant="contained"
            style={{ backgroundColor: '#315382', color: 'white' }}
          >
            Yes
          </Button>
        )}
        <Button
          onClick={handleClose}
          variant="contained"
          color="secondary"
          style={{ color: 'white' }}
        >
          {error ? 'Close' : 'No'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

RemoveOrderFormHeaderDialog.propTypes = propTypes;
RemoveOrderFormHeaderDialog.defaultProps = {};

export default RemoveOrderFormHeaderDialog;
